// removed by extract-text-webpack-plugin
module.exports = {"scrapFormContent":"qempo_ScrapInputBlock_scrapFormContent-2ZruHQ9","inputWrap":"qempo_ScrapInputBlock_inputWrap-O6Wa-V6"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/store/GenericStore/ScrapInputBlock/ScrapInputBlock.scss
// module id = 1980
// module chunks = 0